import {useState} from 'react'
import ImageGallery from '../ImageGallery/ImageGallery'
import backgroundImage_1 from '../../images/countyJail_4.png'
import backgroundImage_2 from '../../images/gaston-header.jpg'
import backgroundImage_3 from '../../images/sunrise-water-authority-header.jpg'
import backgroundImage_4 from '../../images/vita-header.jpg'
import backgroundImage_5 from '../../images/temp-kalama.jpg'
import backgroundImage_6 from '../../images/harold-oliver-header.jpg'
import backgroundImage_7 from '../../images/mainstreet-header.jpg'
import backgroundImage_8 from '../../images/Daimler-header.jpg'
import backgroundImage_9 from '../../images/ninebark-header.jpg'

import gaston_1 from '../../images/gaston_0.jpg'
import gaston_2 from '../../images/gaston_1.jpg'
import gaston_3 from '../../images/gaston_2.jpg'
import gaston_4 from '../../images/gaston_3.png'
import gaston_5 from '../../images/gaston_4.png'
import gaston_6 from '../../images/gaston_5.png'
import county_0 from '../../images/countyJail_0.jpg'
import county_1 from '../../images/countyJail_1.jpg'
import county_2 from '../../images/countyJail_2.jpg'
import county_3 from '../../images/countyJail_3.png'
import county_5 from '../../images/countyJail_5.png'
import county_6 from '../../images/countyJail_6.png'


import kalama_0 from '../../images/kalama-header.jpg'
import kalama_1 from '../../images/Kalama_1.jpg' 
import kalama_2 from '../../images/Kalama_2.jpg'
import vita_0 from '../../images/vita_0.jpg'
import vita_1 from '../../images/vita_1.jpg'
import sunrise_0 from '../../images/sunrise-header.jpg'
import sunrise_1 from '../../images/home_1.jpg'
import sunrise_2 from '../../images/sunrise_1.jpg'
import sunrise_3 from '../../images/sunrise_2.jpg'
import sunrise_4 from '../../images/sunrise_3.jpg'
import sunrise_5 from '../../images/sunrise_4.jpg'
import sunrise_6 from '../../images/sunrise_5.jpg'

import sunrise_7 from '../../images/sunrise_6.jpg'
import sunrise_8 from '../../images/sunrise_7.jpg'
import sunrise_9 from '../../images/sunrise_8.jpg'
import sunrise_10 from '../../images/sunrise_9.jpg'
import sunrise_11 from '../../images/sunrise_10.jpg'
import sunrise_12 from '../../images/sunrise_11.jpg'

import harold_0 from '../../images/harold_0.jpg'
import harold_1 from '../../images/harold_1.jpg'
import main_0 from '../../images/main_0.jpg'
import main_1 from '../../images/main_1.jpg'
import main_2 from '../../images/main_4.jpg'
import main_3 from '../../images/main_5.jpg'
import main_4 from '../../images/main_6.jpg'
import dam_0 from '../../images/dam_0.jpg'
import dam_1 from '../../images/dam_1.jpg'
import dam_2 from '../../images/dam_2.jpg'
import ninebark_0 from '../../images/ninebark_1.jpg'
import ninebark_2 from '../../images/ninebark_5.jpg'

import backgroundImage_13 from '../../images/northplains_1.jpg'
import northplains_1 from '../../images/northplains_2.jpg'
import northplains_2 from '../../images/northplains_3.jpg'
import northplains_3 from '../../images/northplains_4.jpg'

import backgroundImage_11 from '../../images/tillamook_1.jpg'
import tillamook_1 from '../../images/tillamook_2.jpg'
import tillamook_2 from '../../images/tillamook_3.jpg'
import tillamook_3 from '../../images/tillamook_4.jpg'

import backgroundImage_10 from '../../images/king_lasik_2.jpg'
import kinglasik_1 from '../../images/king_lasik_1.jpg'
import kinglasik_2 from '../../images/king_lasik_3.jpg'
import kinglasik_3 from '../../images/king_lasik_4.jpg'

import backgroundImage_12 from '../../images/ai-scaled.png'
import walmart_1 from '../../images/walmart_2.jpg'
import walmart_2 from '../../images/walmart_3.jpg'
import walmart_3 from '../../images/walmart_4.jpg'

import backgroundImage_14 from '../../images/sletten_0.png'

import sletten_2 from '../../images/sletten_0.png'


import backgroundImage_15 from '../../images/chipotle_0.png'
import chipotle_2 from '../../images/chipotle_1.png'
import chipotle_3 from '../../images/chipotle_2.png'
import chipotle_4 from '../../images/chipotle_3.png'
import chipotle_5 from '../../images/chipotle_4.png'
import chipotle_6 from '../../images/chipotle_5.png'
import chipotle_7 from '../../images/chipotle_6.png'
import chipotle_8 from '../../images/chipotle_7.png'

import backgroundImage_16 from '../../images/delta_0.png'
import delta_2 from '../../images/delta_1.png'
import delta_3 from '../../images/delta_2.png'
import delta_4 from '../../images/delta_3.png'
import delta_5 from '../../images/delta_4.png'

import backgroundImage_17 from '../../images/boardwalk_place_apartments_0.png'
import boardwalk_place_2 from '../../images/boardwalk_place_apartments_1.png'
import boardwalk_place_3 from '../../images/boardwalk_place_apartments_2.png'
import boardwalk_place_4 from '../../images/boardwalk_place_apartments_3.png'

import backgroundImage_18 from '../../images/cbc_rollup_1.png'
import cbc_rollup_1 from '../../images/cbc_rollup_0.png';
import cbc_rollup_3 from '../../images/cbc_rollup_2.png';
import cbc_rollup_4 from '../../images/cbc_rollup_3.png';
import cbc_rollup_5 from '../../images/cbc_rollup_4.png';
import cbc_rollup_6 from '../../images/cbc_rollup_5.png';

import backgroundImage_19 from '../../images/woodspring_0.png'
import woodspring_2 from '../../images/woodspring_1.png';
import woodspring_3 from '../../images/woodspring_2.png';
import woodspring_4 from '../../images/woodspring_3.png';

import backgroundImage_20 from '../../images/bletko_1.png'
import bletko_1 from '../../images/bletko_0.png';
import bletko_3 from '../../images/bletko_2.png';
import bletko_4 from '../../images/bletko_3.png';
import bletko_5 from '../../images/bletko_4.png';
import bletko_6 from '../../images/bletko_5.png';

import backgroundImage_22 from '../../images/carson_0.png'
import carson_2 from '../../images/carson_1.png'
import carson_3 from '../../images/carson_2.png'
import carson_4 from '../../images/carson_3.png'
import carson_5 from '../../images/carson_4.png'
import carson_6 from '../../images/carson_5.png'
import carson_7 from '../../images/carson_6.png'

import backgroundImage_23 from '../../images/sksd_0.png'
import sksd_2 from '../../images/sksd_1.png';
import sksd_3 from '../../images/sksd_2.png';
import sksd_4 from '../../images/sksd_3.png';
import sksd_5 from '../../images/sksd_4.png';
import sksd_6 from '../../images/sksd_5.png';

import backgroundImage_24 from '../../images/vic_0.png'
import vic_2 from '../../images/vic_1.png';
import vic_3 from '../../images/vic_2.png';

import backgroundImage_25 from '../../images/misc_0.png'
import misc_2 from '../../images/misc_1.png'
import misc_3 from '../../images/misc_2.png'
import misc_4 from '../../images/misc_3.png'
import misc_5 from '../../images/misc_4.png'
import misc_6 from '../../images/misc_5.png'

import { useNavigate } from 'react-router-dom';
import SEO from '../SEO/SEO';

import Nav from '../Nav/Nav'
import GeneralInfoSection from '../GeneralInfoSection/GeneralInfoSection'
import NavPanel from '../NavPanel/NavPanel'
import Footer from '../Footer/Footer';
import ProjectModal from '../ProjectModal/ProjectModal'

const ProjectsPage = () => {

  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState('ALL PROJECTS');
  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [project, setProject] = useState('')
  const navigate = useNavigate();

  
  const navigateToProject = (projectName) => {
    let project = images.filter((image) => image.projectName == projectName)
    navigate(`/projects/${projectName}`,  { state: project })
  }

   const handleStateUpdate = (projectName) => {
    setProject(projectName)
    navigateToProject(projectName)
   }

  const [titles, setTitles] = useState([
    'ALL PROJECTS',
    'CIVIC & COMMUNITY',
    //'HEALTH CARE',
    //'HIGHER EDUCATION',
    //'HOSPITALITY & RETAIL',
    'INDUSTRIAL',
    'K-12 SCHOOLS',
    'OFFICE & COMMERCIAL',
    //'RELIGIOUS'
  ])

  const [images, setImages] = useState([
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_1,
      images: [county_0, county_1, county_2, county_3,county_5, county_6],
      projectName: 'Clatsop County Jail',
      description: 'This was new construction of a jail that included 5 staircases as well as hundreds of feet of guardrail. We also fabricated an installed new roof access ships ladders.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_2,
      images: [gaston_1, gaston_2, gaston_3, gaston_4, gaston_5, gaston_6],
      projectName: 'Gaston Fire Department',
      description: 'Added moment frames as well as an entry canopy to an existing building. Fabricate and install two seismic frames and canopy, prevailing wage project.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_3,
      images: [sunrise_0, sunrise_1, sunrise_2, sunrise_3, sunrise_4, sunrise_5, sunrise_6, sunrise_7, sunrise_8, sunrise_9, sunrise_10, sunrise_11, sunrise_12],
      projectName: 'Sunrise Water Authority',
      description: 'New construction full Structural and Misc steel package. This project includes a CLT shop and administration building. This is a prevailing wage project which included over 2000 man hours. Full 3D modeling and drawing package was done in house as well as fabrication and installation.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_4,
      images: [vita_0, vita_1],
      projectName: 'VITA covered play structure',
      description: 'This project consisted of erecting a pre engineered metal building. We also installed the T&G roof decking as well as the metal roofing and gutters.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_9,
      images: [ninebark_2, ninebark_0],
      projectName: 'Ninebark Apartments',
      description: 'Full structural and Misc steel package for 8 building apartment complex. Included sunshades, embeds, trash enclosure, ledger angles, signage, and guardrails'

    },
    {
      title: 'K-12 SCHOOLS',
      backgroundImage: backgroundImage_5,
      images: [kalama_0, kalama_1, kalama_2],
      projectName: 'Kalama Elementary School',
      description: 'We Fabricated guard rail and stainless handrailing for 4 stair cases as well as trash enclosure gates, mechanical screens, and roof access ladders.'
    },
    {
      title: 'K-12 SCHOOLS',
      backgroundImage: backgroundImage_6,
      images: [harold_1,harold_0],
      projectName: 'Harold Oliver Middle School',
      description: 'This project consisted of several seismic upgrades as well as the fabrication and installation of a new trash enclosure. We also supplied the covered entry canopy.'
    },
    {
      title: 'INDUSTRIAL',
      backgroundImage: backgroundImage_8,
      images: [dam_0, dam_1, dam_2],
      projectName: 'Daimler Battery Crane',
      description: 'Demolition of existing overhead bridge crane and installation of new 110ft long runway and install of new overhead bridge cranes.'
    },
    {
      title: 'OFFICE & COMMERCIAL',
      backgroundImage: backgroundImage_7,
      images: [main_2, main_3, main_4, main_0, main_1],
      projectName: 'Main St Restaurants',
      description: 'Full Structural and Misc Steel Package to renovate an existing bank and turn it into 5 restaurants. Seismic and structural upgrades included new steel columns and a steel deck frame on the roof for an outdoor bar. One new staircase, over 300 ft of stainless cable railing, and framing for a new elevator.'
    },
    {
      title: 'OFFICE & COMMERCIAL',
      backgroundImage: backgroundImage_13,
      images: [northplains_1, northplains_2, northplains_3],
      projectName: 'North Plains Public Works',
      description: 'Misc Steel Package for new public works building located in North Plains Oregon. This project included custom guard railing as well as roll up door surround frames'
    },
    {
      title: 'OFFICE & COMMERCIAL',
      backgroundImage: backgroundImage_12,
      images: [walmart_1, walmart_2, walmart_3, sletten_2],
      projectName: 'Walmart Online Order Pickup',
      description: 'Included structural steel columns and beams as well as 4,000 sq ft of pan decking. We also erected a pre-engineered metal canopy on the site. Fabricated and installed 7,500 sqft column, beam, and roof decking structure.'
    },
    {
      title: 'OFFICE & COMMERCIAL',
      backgroundImage: backgroundImage_10,
      images: [kinglasik_1, kinglasik_2, kinglasik_3],
      projectName: 'King Lasik Railings',
      description: 'Powder coated guardrail with stainless cable infill and #4 satin finish stainless handrail.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_11,
      images: [tillamook_1, tillamook_2, tillamook_3],
      projectName: 'Tillamook Parking Deck',
      description: 'Work consisted of adding new columns and beams as well as 1,000 sq ft of pan decking.'
    },

    /*new set*/
    {
      title: 'OFFICE & COMMERCIAL',
      backgroundImage: backgroundImage_15,
      images: [chipotle_2, chipotle_3, chipotle_4, chipotle_5, chipotle_6, chipotle_7, chipotle_8],
      projectName: 'Union Ridge Chipotle and Starbucks',
      description: 'Fabricate and install Structural and Misc steel package for two buildings'
    },
    {
      title: 'INDUSTRIAL',
      backgroundImage: backgroundImage_16,
      images: [delta_2, delta_3, delta_4, delta_5],
      projectName: 'Delta Logistics Tilt Up Building',
      description: 'Supply and install structural Package, Embeds, Columns, Entry Canopy, Wind Wall Frame, Trash enclosure, bollards.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_17,
      images: [boardwalk_place_2, boardwalk_place_3, boardwalk_place_4],
      projectName: 'Boardwalk Place Appartments',
      description: 'Supply strcutral Package, Columns, first floor framing, Railings, Roof Access Ladder.'
    },
    {
      title: 'INDUSTRIAL',
      backgroundImage: backgroundImage_18,
      images: [cbc_rollup_1,cbc_rollup_3,cbc_rollup_4,cbc_rollup_5,cbc_rollup_6],
      projectName: 'CBC Roll Up Door Frame',
      description: ' Fabricate and install two 60’ tall columns with header, retrofit to 80 year old building. We also completed the rough carpentry, siding and break metal.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_19,
      images: [woodspring_2, woodspring_3, woodspring_4],
      projectName: 'Woodspring Suites Railings',
      description: 'Fabricate and install interior and exterior railings, trash enclosure.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_20,
      images: [bletko_1, bletko_3, bletko_4, bletko_5, bletko_6],
      projectName: 'Bletko Custom Staircase',
      description: 'Fabricate and install custom staircase with powder coated finish, stainless steel cable railing and hardware.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_22,
      images: [carson_2, carson_3, carson_4, carson_5, carson_6, carson_7],
      projectName: 'Carson Commons Appartments',
      description: 'Supply and install canopies, juliet balconies, interrior and exterior Railings, Roof Access Ladder, trash enclosure.'
    },
    {
      title: 'K-12 SCHOOLS',
      backgroundImage: backgroundImage_23,
      images: [sksd_2, sksd_3, sksd_4, sksd_5, sksd_6],
      projectName: 'SKSD Entry Vestibules',
      description: 'Supply and install canopies and mis steel packages for three school entry remodels.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_24,
      images: [vic_2, vic_3],
      projectName: 'The VIC Cantilevered canopy',
      description: 'Supply and install cantilevered canopy.'
    },
    {
      title: 'CIVIC & COMMUNITY',
      backgroundImage: backgroundImage_25,
      images: [misc_2, misc_3, misc_4, misc_5, misc_6],
      projectName: 'Miscellaneous Patio Covers',
      description: 'Install Patio Covers.'
    },
    // Add more image URLs as needed
  ]);
  
  
  return (
    <div className="w-full mt-32 bg-zinc-800">
      <SEO 
        title="COJON: Mechanical Engineering & Construction"
        description="Portland Metro & Southwest Washington Commercial & Industrial Contracting"
        name="COJON"
        type="website"
        index
      />
      
      {open && <NavPanel setOpen={setOpen}/>}
      <Nav setOpen={setOpen}/>
      {/* main content */}
      {projectModalOpen && <ProjectModal project={project} closeProjectModal={() => setProjectModalOpen(prev => !prev)}/>}
      <h2 className="text-left text-2xl px-4 pt-8 text-zinc-300 font-semibold">{filter}</h2>
        
      <div className='flex flex-wrap p-4 '>
        {titles.map((title, index) => {
          return (
            <div className="py-2" key={index}>
              {index > 0 && <span className="px-2 text-zinc-600">/</span>}
              { filter == title ?
                <a className="text-zinc-300 hover:cursor-pointer"
                  onClick={() => {
                    setFilter(title)
                  }}
                >{title}</a> :
                <a className="text-zinc-600 hover:cursor-pointer"
                  onClick={() => {
                    setFilter(title)
                  }}
                >{title}</a>
              }
        
            </div>

          )
        })}

      </div>
      <ImageGallery images={filter !== "ALL PROJECTS" ? images.filter((image) => image.title == filter) : images} openModal={handleStateUpdate} />
 
      <GeneralInfoSection />
      <Footer />
    
    </div>
    
  )
}

export default ProjectsPage